import React, {useEffect, useState} from 'react';
import {Alert, Pressable, Text, View} from 'react-native';
import ModalContainer from '../../components/layout/modalContainer';
import {ThemeContext} from '../../contextAPI/themeContext';
import {style} from './styles';
import {FixedValue, TEXT} from '../../constants';
import PrimaryButton from '../../components/button/primaryButton';
import ModalBack from '../../components/renderSvgs/modalBack';
import useTopDetails from '../../hooks/componentHooks/useTopDetailsHooks';
import {NotesModel} from '../../types/reducerTypes/searchTabStoreType';
import RadioSelectButton from '../../components/renderSvgs/radioSelectButton';
import RadioUnselectButton from '../../components/renderSvgs/radioUnselectButton';
import {TopDetailContext} from '../../contextAPI/topDetailContext';
import QunatitySelector from '../../components/smallDesigns/qunatitySelector';
import { showAlertForExceedSelectedNumber, showAlertForZeroSelectedNumber } from '../../utils/helperFunctions';

interface INotesModalProps {
  notesData: NotesModel | null;
  showModal: boolean;
  buttonLoader: boolean;
  isNotesEditMode: boolean;
  setCloseModal: (val: boolean) => void;
}

const NotesSelectedModal = (props: INotesModalProps) => {
  const {ColorTheme} = React.useContext(ThemeContext);
  const {styles} = style(ColorTheme);
  const {topDetail, openSelectNotesModal} = React.useContext(TopDetailContext);
  const {showModal, setCloseModal, buttonLoader} = props;
  const {values, handleSubmit, setFieldValue, resetForm} =
    useTopDetails();
  const [isLabelVisible, setIsLabelVisible] = useState(false);
  const [selectedNoteType, setSelectedNoteType] = useState<
    'select' | 'second' | null
  >(null);
  const [quantity, setQuantity] = useState(0);
  const MAX_QUANTITY = (topDetail?.quantity ?? 1) - 1;

  const showLimitReachedAlert = () => {
    showAlertForExceedSelectedNumber();
  };

  const handlePlus = () => {
    if (quantity < MAX_QUANTITY) {
      setQuantity(prev => prev + 1);
    } else {
      showLimitReachedAlert();
    }
  };

  const handleMinus = () => {
    setQuantity(prev => (prev > 0 ? prev - 1 : 0));
  };

  const handleQuantityChange = (val: number) => {
    if (val > MAX_QUANTITY) {
      showLimitReachedAlert();
      setQuantity(MAX_QUANTITY);
      return;
    } else if (val < 0) {
      setQuantity(0);
      return
    } else {
      setQuantity(val);
    }
  };
  useEffect(() => {
    setSelectedNoteType(null);
    values.SelectedTops = false;
    values.AllTops = false;
    setQuantity(0);
    setFieldValue(TEXT.SELECT_NOTE, '0');
    setIsLabelVisible(false);
  }, [openSelectNotesModal]);
  useEffect(() => {
    setFieldValue(TEXT.SELECT_NOTE, quantity);
  }, [quantity]);
  const closeModal = () => {
    resetForm();
    values.SelectedTops = false;
    values.AllTops = false;
    setQuantity(0);
    setFieldValue(TEXT.SELECT_NOTE, '0');
    setIsLabelVisible(false);
    setCloseModal(false);
  };
  const _RadioSelectButton = (): JSX.Element => (
    <View pointerEvents="none">
      <RadioSelectButton
        width={FixedValue.CONSTANT_VALUE_28}
        height={FixedValue.CONSTANT_VALUE_28}
      />
    </View>
  );

  const _RadioUnselectButton = (): JSX.Element => (
    <View pointerEvents="none">
      <RadioUnselectButton
        width={FixedValue.CONSTANT_VALUE_28}
        height={FixedValue.CONSTANT_VALUE_28}
      />
    </View>
  );
  return (
    <ModalContainer visible={showModal} onPressOutside={closeModal}>
      <View style={styles.subContainer}>
        <View style={styles.container}>
          <Text style={styles.titleText}>{TEXT.CHOOSE_HOW_TO_APPLY_NOTE}</Text>
          <Pressable onPress={closeModal}>
            <ModalBack />
          </Pressable>
        </View>

        <Pressable
          onPressIn={() => setSelectedNoteType('select')}
          onPress={() => {
            setIsLabelVisible(true);
            (values.AllTops = false), (values.SelectedTops = true);
          }}
          style={[styles.notePressable]}>
          <View style={styles.noteRow}>
            {selectedNoteType === 'select'
              ? _RadioSelectButton()
              : _RadioUnselectButton()}
            <Text style={styles.noteText}>{TEXT.SECOND_SELECT_NOTE_TEXT}</Text>
          </View>
        </Pressable>

        {isLabelVisible && (
          <View style={styles.noteTextContainer}>
             <QunatitySelector
             count={quantity}
             onPlusPress={handlePlus}
             onMinusPress={handleMinus}
             isInputQuantity={true}
             onChangeQuantity={handleQuantityChange}
             setIskeyboardFocused={isFocused => console.log('Focused:', isFocused)}
             checkQuantityOnOnChange={true}
             textInputSupportDarkTheme={true}
           />
          </View>
        )}

        <Pressable
          onPressIn={() => setSelectedNoteType('second')}
          onPress={() => {
            setIsLabelVisible(false);
            (values.AllTops = true), (values.SelectedTops = false);
          }}
          style={[styles.notePressableSecond]}>
          <View style={styles.noteRow}>
            {selectedNoteType === 'second'
              ? _RadioSelectButton()
              : _RadioUnselectButton()}
            <Text style={styles.noteText}>{TEXT.SELECT_NOTE_TEXT}</Text>
          </View>
        </Pressable>
        <PrimaryButton
          buttonLabel={TEXT.SUBMIT}
          onPress={() => {
            if (selectedNoteType === 'select' && quantity === 0) {
              showAlertForZeroSelectedNumber()
              return;
            }
            handleSubmit();
          }}
          isDisabled={!(selectedNoteType !== null) || buttonLoader}
          isLoading={buttonLoader}
        />
      </View>
    </ModalContainer>
  );
};

export default NotesSelectedModal;
